import PriorityDropdown from '@/features/Feedback/field/Priority/PriorityDropdown';
import useFeedbackListStore from '@/stores/Feedback/FeedbackListStore';

import { useFeedbackDetailContext } from '../../context/FeedbackDetailContext';
import { PropertyRowWrapper } from './PropertyRowWrapper';
import type { CommonFieldProps } from './types';

export const PriorityField = (
  props: CommonFieldProps & {
    feedback_alias: string;
    priority: PriorityKeyT;
  },
) => {
  const changePriority = useFeedbackListStore((state) => state.changePriority);
  const { updateDetail } = useFeedbackDetailContext();

  if (!props.showFull && !props.priority) return null;

  return (
    <PropertyRowWrapper {...props}>
      <PriorityDropdown
        name={'priority'}
        selected={props.priority}
        onSelect={(key) => {
          changePriority(props.feedback_alias, key);
          updateDetail({
            priority: key,
          });
        }}
      />
    </PropertyRowWrapper>
  );
};
